import { Navigate, Outlet, NavigateProps, useLocation } from 'react-router-dom';

export interface ProtectedRouteProps {
  isAllowed: boolean;
  redirectTo?: NavigateProps['to'];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ isAllowed, redirectTo = '/' }) => {
  let location = useLocation();

  if (!isAllowed) return <Navigate to={redirectTo} state={{ from: location }} replace />;

  return <Outlet />;
};

export default ProtectedRoute;
